import FileUpload from "@iewc/MobiusOverrides/FileUpload/FileUpload";
import setFieldValue from "@iewc/Store/Handlers/CreateAccount/SetFieldValue";

import { CustomActions, CustomState } from "@iewc/Store/Reducers";
import {
    OwnProps,
    setRequestFormEffects,
} from "@iewc/Widgets/CreateAccount/FormBaseComponent";
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import getFileExtension from "@insite/client-framework/Common/Utilities/getFileExtension";
import siteMessage from "@insite/client-framework/SiteMessage";
import setIsBadFile from "@insite/client-framework/Store/Components/OrderUpload/Handlers/SetIsBadFile";
import setUploadLimitExceeded from "@insite/client-framework/Store/Components/OrderUpload/Handlers/SetUploadLimitExceeded";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Tooltip from "@insite/mobius/Tooltip";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import parse from "html-react-parser";
import * as React from "react";
import { connect, DispatchProp, ResolveThunks } from "react-redux";
import { css } from "styled-components";


const styles = {
    wrapper: {
        css: css`
            padding: 20px 30px;
            background-color: #fff;
            display: flex;
            flex-direction: column;
            gap: 15px;
        `,
    } as any,
};

const mapStateToProps = (state: CustomState) => ({
    file: state.customCreateAccountForm.fieldValues.file as any,
    taxExempt: state.customCreateAccountForm.fieldValues.taxExempt
});

const mapDispatchToProps = {
    setFieldValue,
};

interface CustomProps {
    heading: string;
    copy: string;
    label: string;
}

type Props = CustomProps & OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    DispatchProp<CustomActions>;

const FileUploadWidget: React.FC<Props> = ({
    setFieldValue: widgetSetFieldValue,
    file,
    taxExempt,
    heading,
    copy,
    label
}) => {
    const isRequired = taxExempt === "true";
    const [fieldErrorMessage, setFieldErrorMessage] = React.useState("");

    const validate = () => {
        let errorMessage = "";

        if (!isRequired) {
            errorMessage = "";
        }

        if (!file) {
            errorMessage = translate("File is required");
        } else if (file && getFileExtension(file.name)?.toLowerCase?.() !== "pdf") {
            errorMessage = translate("File type must be PDF");
        } else if (file && file.size > 3e+6) {
            errorMessage = translate("File size exceeds 3MB");
        }

        setFieldErrorMessage(errorMessage);
        return !errorMessage;
    }

    setRequestFormEffects(isRequired, file, "file", validate);

    const fieldChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        widgetSetFieldValue({ key: "file", value: event.target.files?.[0] } as any);
    };

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography as="div">
                {parse(copy, parserOptions)}
            </Typography>
            <FileUpload
                fileName={file?.name || ""}
                accept=".pdf"
                error={fieldErrorMessage}
                required={isRequired}
                onChange={fieldChangeHandler}
                buttonText={translate("Add a file")}
                placeholder={translate("No file selected")}
            />
        </StyledWrapper>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(FileUploadWidget);
